import { render, staticRenderFns } from "./VehicleApplication.vue?vue&type=template&id=28a15143&scoped=true"
import script from "./VehicleApplication.vue?vue&type=script&lang=js"
export * from "./VehicleApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a15143",
  null
  
)

export default component.exports